import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonError: React.FC<MprcButtonProps> = ({ title, text, color = "error", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonError.text;
    const lTitle = title || theme.buttons.ButtonError.title;
    return (
        <MprcButton
            {...rest}
            color={color}
            title={lTitle}
            text={lText}
        />
    );
};
